import { BriefcaseBusiness } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { pastEvents } from "@/data/eventOrganizerContent";

const PastEventsSection = () => {
  return (
    <section id="past-events" data-testid="past-events-section" className="space-y-10 py-24">
      <div className="max-w-4xl space-y-4">
        <p
          data-testid="past-events-eyebrow-text"
          className="inline-flex items-center gap-2 rounded-full border border-fuchsia-200 bg-fuchsia-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-fuchsia-700"
        >
          <BriefcaseBusiness className="h-3.5 w-3.5" />
          Past Events
        </p>
        <h2 data-testid="past-events-heading" className="text-3xl leading-tight text-violet-950 md:text-5xl">
          Corporate events delivered across conferences, summits, and industry forums.
        </h2>
        <p data-testid="past-events-subheading-text" className="text-sm text-stone-600 md:text-base">
          Event history listed as referenced in your uploaded rate card.
        </p>
      </div>

      <Card data-testid="past-events-card" className="border-fuchsia-200 bg-violet-50/75">
        <CardContent className="grid gap-3 p-6 md:grid-cols-2">
          {pastEvents.map((item, index) => (
            <div
              key={`${item.event}-${item.year}`}
              data-testid={`past-event-item-${index + 1}`}
              className="rounded-xl border border-fuchsia-200 bg-fuchsia-100/65 p-4"
            >
              <p data-testid={`past-event-year-${index + 1}`} className="text-xs font-semibold uppercase tracking-[0.14em] text-fuchsia-700">
                {item.year}
              </p>
              <p data-testid={`past-event-name-${index + 1}`} className="mt-1 text-sm font-semibold leading-relaxed text-violet-950 md:text-base">
                {item.event}
              </p>
              <p data-testid={`past-event-client-${index + 1}`} className="mt-1 text-xs uppercase tracking-[0.14em] text-violet-700">
                {item.client}
              </p>
              <p data-testid={`past-event-role-${index + 1}`} className="mt-2 text-sm text-violet-900/90">
                Role: {item.role}
              </p>
              <p data-testid={`past-event-location-${index + 1}`} className="text-sm text-violet-800/80">
                Location: {item.location}
              </p>
            </div>
          ))}
        </CardContent>
      </Card>
    </section>
  );
};

export default PastEventsSection;